import { render, staticRenderFns } from "./NeedFromTeam.vue?vue&type=template&id=234488ba&scoped=true&"
import script from "./NeedFromTeam.vue?vue&type=script&lang=js&"
export * from "./NeedFromTeam.vue?vue&type=script&lang=js&"
import style0 from "./NeedFromTeam.vue?vue&type=style&index=0&id=234488ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234488ba",
  null
  
)

export default component.exports